import Button from '../UI/Button/Button';
import styles from './PhoneCallModal.module.css';
import { Link } from 'react-router-dom';
import cn from 'classnames';

type PhoneCallModalProps = {
  isActive: boolean;
  onClose: () => void;
};

export default function PhoneCallModal({ isActive, onClose }: PhoneCallModalProps) {
  const handleBackgroundClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={cn(styles.modal, isActive && styles.active, !isActive && styles.hidden)}
      onClick={handleBackgroundClick}
    >
      <div className={styles.modal_wrapper}>
        <span className={styles.close_button} onClick={onClose}></span>
        <div className={styles.top}>
          <p className={cn('text_body_b2')}>Это наш телефон</p>
          <h2>+7 938 151-22-22</h2>
        </div>
        <div className={styles.line}></div>
        <div className={styles.bottom}>
          <p className={cn('text_body_b2')}>
            Мы&nbsp;работаем с&nbsp;9:00 до&nbsp;18:30 по&nbsp;будням и&nbsp;с&nbsp;9:00
            до&nbsp;17:00 по&nbsp;выходным. Если не&nbsp;ответили сразу&nbsp;&mdash; обязательно
            перезвоним. При этом мы&nbsp;всегда доступны в&nbsp;WhatsApp или Telegram.
          </p>
          <Link to={'tel:+79381512222'}>
            <Button colorType='blue' roundType='small_rounded' width='100%'>
              Позвонить
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
